<script lang="ts">
  import _ from "lodash";
  import Flash from "@shared/services/flashv2.js";
  import type { RetailerType } from "@shared/types/Retailer";
  import LocationInfoForm from "./Form.svelte";
  import SettingsPageWrapper from "@modern/components/retailer/settings/PageWrapper.svelte";
  import retailerContext from "@modern/services/retailer_context";
  import PunchoutSessionStore from "@retailer/svelte/stores/PunchoutSessionStore";

  let retailer: RetailerType = retailerContext.get();

  let allRetailers: RetailerType[] = _.clone(window["$rootScope"].retailers);
  if (!retailer) {
    Flash.now({
      type: "warning",
      message: "We seem to have had a problem - please refresh and try again.",
    });
  }
  let retailerFilter = "";

  const addLocation = function () {
    sessionStorage.setItem("signupProgress", "2");
    window.location.href = "/sign-up/retailer";
  };

  const isCurrentRetailer = function (retailer) {
    return retailer.id === window["$rootScope"].currentRetailerId;
  };

  const filterRetailers = function () {
    allRetailers = _.filter(window["$rootScope"].retailers, function (retailer) {
      return retailer.name.toLowerCase().indexOf(retailerFilter.toLowerCase()) > -1;
    });
  };

  const onClickRetailer = retailer => {
    if (allowLocationManagement) {
      retailerContext.setRetailer(retailer.id);
    }
  };

  $: allowLocationManagement = !$PunchoutSessionStore?.is_active_punchout;
</script>

<SettingsPageWrapper>
  <div class="margin-bottom--small">
    <div class="padding--small">
      <div class="grid-row padding-bottom--small align--middle">
        <div class="grid-col c6-12 show--md">
          <div class="default-title--regular">Locations</div>
        </div>
        {#if allowLocationManagement}
          <div class="grid-col c12-12 c6-12--md align-right">
            <button
              class="button button--label button--small--md button--primary"
              on:click={addLocation}>Add Location</button
            >
          </div>
        {/if}
      </div>

      {#if allowLocationManagement}
        <div class="input-wrapper full-width margin-top--small--md margin-bottom--small--md">
          <input
            type="text"
            class="input"
            placeholder="Filter Locations..."
            id="retailerFilterInput"
            bind:value={retailerFilter}
            on:keyup={filterRetailers}
          />
        </div>
      {/if}

      <div class="grid-row">
        {#each allRetailers as retailer}
          <div class="grid-col c12-12 c6-12--md" retailer-id={retailer.id}>
            <div
              class="tile padding--default margin-top--small"
              class:cursor-pointer={allowLocationManagement}
              class:retailer-select-popover__location={allowLocationManagement}
              id="retailer_{retailer.id}"
              class:retailer-select-popover__location--selected={isCurrentRetailer(retailer)}
              on:click={() => onClickRetailer(retailer)}
              attr-id="retailer_{retailer.id}"
            >
              <p class="ellipsis notranslate"><strong>{retailer.name}</strong></p>
              <p class="ellipsis notranslate">{retailer.address1}</p>
              <p class="ellipsis notranslate">{retailer.address2 || ""}</p>
              <p class="ellipsis notranslate">
                {retailer.city}{#if retailer.state}<span>,</span>{/if}
                {retailer.state}
                {retailer.zip}
              </p>
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>

  <LocationInfoForm bind:retailer />
</SettingsPageWrapper>
